module.exports = __webpack_public_path__ + "img/tuandui.daf88cf8.png";